module.exports = __webpack_public_path__ + "img/add_icon.c71ea140.svg";